import useFlag from './useFlag';

const FLAG = 'flex.content.admin-notes';

export function useAdminNotesEnabled() {
  const isEnabled = useFlag<boolean>(FLAG, false);

  return Boolean(isEnabled);
}
